export const VENDOR_PARAMS = [
  { param: 'ttclid', vendor: 'TIKTOK' },
  { param: 'fbclid', vendor: 'META' },
  { param: 'pixel_click_id', vendor: 'GEEMEE' },
  { param: '3s_clickid', vendor: '3SNET' },
  { param: 'ts_clickid', vendor: 'TRAFFICSTARS' },
]

export const detectVendorClick = (searchParams) => {
  for (const { param, vendor } of VENDOR_PARAMS) {
    const traceId = searchParams.get(param)
    if (traceId) return { traceId, vendorCode: vendor }
  }
  return null
}

export const SENSITIVE_QUERY_KEYS = new Set(['token', 'otp', 'phone', 'code', 'password', 'auth', 'access_token', 'x', 'pwd'])

export const stripAuthParams = (href) => {
  try {
    const url = new URL(href)
    const sensitiveKeys = [...url.searchParams.keys()].filter((key) => SENSITIVE_QUERY_KEYS.has(key.toLowerCase()))
    if (sensitiveKeys.length === 0 && !url.hash) return href

    sensitiveKeys.forEach((key) => url.searchParams.delete(key))
    url.hash = ''
    return url.toString()
  } catch {
    return href
  }
}

export const DEFAULT_AC = 'officialdefault'

export const resolveAc = ({ attribution, cookieAc, authed, agentId }) => {
  const attributedAc = attribution ? attribution.ac : cookieAc
  return attributedAc || (authed ? agentId : undefined) || DEFAULT_AC
}

export const resolveActualAgentId = ({ authed, agentId, ac }) => {
  if (!authed || agentId === undefined || agentId === null) return undefined
  return String(agentId) !== String(ac) ? String(agentId) : undefined
}

export const EXTRA_KEYS = new Set([
  'value',
  'currency',
  'transaction_id',
  'isFirst',
  'paymentMethod',
  'activityName',
  'activityNo',
  'location',
  'query',
  'searchTag',
  'method',
])

export const buildExtra = (payload) => {
  const extra = {}
  if (!payload) return extra
  for (const key of EXTRA_KEYS) {
    if (payload[key] !== undefined) extra[key] = payload[key]
  }
  return extra
}

export const buildConversionBody = ({
  traceId,
  vendorCode,
  capturedAt,
  eventTime,
  eventId,
  uniqId,
  event,
  ac,
  actualAgentId,
  price,
  externalId,
  site,
  fbc,
  fbp,
  ttp,
  eventSourceUrl,
  extra,
  utm,
}) => ({
  traceId,
  vendorCode,
  capturedAt,
  eventTime,
  eventId,
  uniqId,
  event,
  ac,
  actualAgentId,
  price,
  externalId,
  site,
  fbc,
  fbp,
  ttp,
  eventSourceUrl,
  extra,
  utm,
})

const UTM_TTL_MS = 30 * 24 * 60 * 60 * 1000

export const parseStoredUtm = (raw, nowMs = Date.now()) => {
  if (!raw) return undefined
  try {
    const { utm, ts } = JSON.parse(raw)
    if (!utm || typeof ts !== 'number') return undefined
    if (nowMs - ts > UTM_TTL_MS) return undefined
    return utm
  } catch {
    return undefined
  }
}

export const parseAttribution = (search) => {
  const withoutHash = String(search ?? '').split('#')[0]
  const queryIndex = withoutHash.indexOf('?')
  const query = queryIndex >= 0 ? withoutHash.slice(queryIndex + 1) : withoutHash
  const params = new URLSearchParams(query)
  const click = detectVendorClick(params)
  return {
    traceId: click?.traceId,
    vendorCode: click?.vendorCode,
    ac: params.get('ac') || undefined,
    price: params.get('price') || undefined,
  }
}
